export default "__VITE_ASSET__HFEDopG3__"